import React from "react";
import {TwoSectionSubTitle, TwoSectionText, TwoSectionTitle} from "@/Components/TwoSection";
import {Link} from "@inertiajs/inertia-react";
import {Heading2} from "@/Components/Elements";
import {formatCurrency} from "@/Helpers/helpers";
const PrivacySection1 = ({ reverse = false, children }) => {
    return (
        <div className="py-section container">
            <div className="mb-14 text-center">
                <p className="mb-1 font-script text-4xl text-gray-400 lg:text-5xl">
                    منصة إعمار
                </p>
                <Heading2 className=" mb-5 ">
                    سياسة الخصوصية
                </Heading2>
                <p className="font-text">
                    إن سياسة الخصوصية، والبنود، والأحكام الواردة في هذه الوثيقة (“سياسة الخصوصية”) تنطبق على موقعنا ,واي تطبيق او موقع يتبع لمنصة إعمار لخدمات الأعمال  على شبكة الإنترنت وأية مراسلات تتم من خلال البريد الإلكتروني بينك وبين منصة إعمار لخدمات الأعمال  (وتشمل الصيغ “منصة إعمار لخدمات الأعمال”  أو  “نحن”) المرسلة من خلال الموقع او البريد الالكتروني للشركة
                </p>

                <p className="font-text">
                    إن الصيغ التالية إلى “أنت”، “بك” و “لك” إشارات إلى الشخص (الأشخاص) الذين يتصفحون مواقع الشركة.
                </p>

                <p className="font-text">
                </p>

            </div>
            <div className="mb-14">
                <p className="font-text">
                    إن سياسة الخصوصية هذه (الي جانب شروطنا القانونية) ترسي الأساس الذي تستند عليه أية بيانات شخصية تصلنا من طرفك، أو التي تقدمها لنا، وسوف تتم معالجتها من قبلنا. يرجى قراءة ما يلي بعناية لفهم وجهات نظرنا والممارسات المتعلقة ببياناتك الشخصية وكيفية التعامل معها.
                </p>

                <p className="font-text">
                    تدرج شروطنا القانونية بموجب سياسة الخصوصية هذه، كما هو منصوص عليها بشكل كامل.
                </p>

                <p className="font-text">
                    أي بند في هذه الخصوصية لا يتفق أو يتعارض مع أي بند من شروطنا القانونية، يجب أن تثبت سياسة الخصوصية هذه.
                </p>

                <p className="font-text">
                    استخدامك للموقع يشير إلى أنك قد قرأت وفهمت وقبلت دون قيد أو شرط للأحكام الواردة في سياسة الخصوصية هذه، ويشكل هذا القبول ملزمة قانونيا لجميع البنود والشروط الواردة في هذه الخصوصية الخاصة بك. إذا كنت لا توافق على شروط سياسة الخصوصية هذه، يرجى التوقف عن الدخول إلى الموقع، وعرض أو استخدام الموقع على الفور.
                </p>

                <p className="font-text">
                    نحن نحتفظ بالحق في تغيير محتويات موقعنا، بما في ذلك سياسة الخصوصية هذه في أي وقت، عن طريق نشر مثل هذه التغييرات على موقعنا. وعليه فإن المسؤولية تقع على عاتقك بالتعرف على سياسة الخصوصية بانتظام للتأكد من أنك على علم بأي تغييرات. سيتم نشر النسخة الأحدث من سياسة الخصوصية هذه على الموقع وسوف تحل محل جميع الإصدارات السابقة من سياسة الخصوصية هذه. إن متابعة استخدامك لهذا الموقع بعد نشر أي تغييرات من هذا القبيل هو تأكيد على موافقتك على سياسة الخصوصية المعدلة
                </p>
                <Heading2 className=" mb-5 ">
                    جمع المعلومات
                </Heading2>
                <p className="font-text">
                    يجوز لنا جمع نوعين من المعلومات عنك من خلال الموقع، هما:
                </p>
                <ul>
                    <li>1.	إن المعلومات الشخصية المقدمة لنا من قبلك في وقت التسجيل الطوعي (أو بعده) للخدمات المقدمة من قبلنا مثل (ولكن ليس على سبيل الحصر) اسمك وعنوان البريد الإلكتروني ورقم بطاقة الائتمان الخاصة بك، تاريخ انتهاء الصلاحية، ورمز التحقق أو معلومات الحساب المصرفي، العنوان البريدي، رقم الهاتف، تاريخ الميلاد، الجنس، الجنسية و / أو معلومات الموقع الجغرافي الخاص بك (“معلومات شخصية”)؛</li>
                    <li>2.	المعلومات المجمعة من خلال أنظمتنا، والتي تتبع حركة المرور إلى مواقعنا ولكن لا تتصل بك شخصيا، مثل نوع المتصفح، اسم نطاق ووقت الدخول إلى الموقع. وتستخدم هذه المعلومات لأغراض البحث الخاصة بنا وهي منفصلة عن أية معلومات شخصية.</li>
                    <li>3.	فشلك في تقديم المعلومات الشخصية الضرورية عند الطلب قد يؤدي إلى عدم توفير بعض الخدمات لك.</li>
                    <li>4.	من خلال تقديمك هذه المعلومات الشخصية إلينا فإنك تقر وتوافق على أن المعلومات التي قدمت (بخلاف رقم بطاقة الائتمان وتاريخ انتهاء الصلاحية، ورمز التحقق أو معلومات الحساب المصرفي الخاص بك) ليست سرية، ويجب ألا تعتبر سرا.</li>
                </ul>

                <Heading2 className=" mb-5 ">
                    الإفصاح عن المعلومات
                </Heading2>
                <ul>
                    <li>•	أي معلومات شخصية نجمعها عنك لطرف ثالث لأغراض توفير خدمات إضافية لك.</li>
                    <li>•	تتبع المعلومات المجمعة وغيرها من المعلومات التي لا تحدد هويتك الشخصية إلى طرف ثالث.</li>
                    <li>•	معلوماتك الشخصية المقدمة إلى أطراف ثالثة، عندما نعتقد بحسن نية أنها مطلوبة سيتم ذلك بموجب القانون أو أي هيئة حكومية مخولة.</li>
                    <li>•	 لن نشارك معلوماتك الشخصية مع أي طرف ثالث (غير الجهات التابعة لمنصة إعمار لخدمات الاعمال) إلا إذا كنت قد قدمت موافقتك الصريحة على ذلك. نحن ملتزمون بالحفاظ على معايير أمنية وإجراءات صارمة بهدف منع الدخول غير المصرح به إلى البيانات الخاصة بك من قبل طرف ثالث. قمنا بتنفيذ إجراءات مادية وإلكترونية وإدارية لحماية وتأمين المعلومات الشخصية التي نجمعها.</li>
                    <li>•	عند إدخال معلومات بطاقة الائتمان الخاصة بك، نستخدم اتصال آمن لاسترداد هذه المعلومات وتمريرها إلى معالج دفع آمن ومخول للطرف الثالث.</li>

                </ul>
                <p className="font-text">
                    لا نحتفظ بمعلومات بطاقة الائتمان الخاصة بك. معالج الدفع الآمن المخول للطرف الثالث يحتفظ ويستخدم معلومات بطاقة الائتمان لغرض عمليات الدفع نيابة عنك.
                </p>

                <p className="font-text">
                    على الرغم من أننا نتخذ جميع التدابير المعقولة لمنع الدخول غير القانوني إلى المعلومات الشخصية، فإننا لا نستطيع التأكيد بأن أي طرف ثالث سيقوم بالدخول غير القانوني إلى المعلومات الشخصية التي تقدمها لنا ونحن نقترح عليك أن تأخذ جميع الاحتياطات اللازمة. لا توجد طريقة للانتقال عبر الإنترنت، أو طريقة تخزين إلكترونية، بما في ذلك البريد الإلكتروني، وغير آمنة 100٪. لا يمكننا تحمل مسؤولية أو تبعة الدخول غير القانوني أو غير المصرح به من قبل أي طرف ثالث على المعلومات الشخصية الخاصة بك.
                </p>

                <Heading2 className=" mb-5 ">
                    الاستخدام
                </Heading2>

                <p className="font-text">
                    قد نستخدم المعلومات الشخصية التي نجمعها في الاتي : :
                </p>
                <ul>
                    <li>1-	للتحقق من هويتك ومساعدتك إذا كنت قد نسيت كلمة المرور أو تفاصيل تسجيل الدخول الخاصة بك على أي من موقعنا للمساعدة في توفير الخدمات التي طلبتها.</li>
                    <li>2-	لتقديم مزيد من المعلومات لك حول المواقع والخدمات الأخرى أو التي نعتبرها قد تكون ذات فائدة لك؛</li>
                    <li>3-	للتسويق في المستقبل، واستخدامها لأغراض ترويجية وإعلامية، بما فيها من القيام بعملية التسويق المباشر، وأبحاث السوق والدراسات الاستقصائية؛</li>
                    <li>4-	لضمان تزويدك بالمعلومات الأكثر ملاءمة لك ولاهتماماتك</li>
                    <li>5-	لأي استخدام آخر بعد الحصول على موافقتك</li>
                </ul>
                <p className="font-text">
                    سنسعى للحصول على موافقتك، في حال رغبنا باستخدام المعلومات الشخصية الخاصة بك لأغراض أخرى غير تلك التي كنت قد وافقت إليها سابقا.
                </p>

                <p className="font-text">
                    سوف نحتفظ بالمعلومات الشخصية التي تقدمها لنا طالما كانت ضرورية بشكل معقول للأغراض الواردة في سياسة الخصوصية هذه.
                </p>

                <Heading2 className=" mb-5 ">
                    الكوكيز والمتابعة
                </Heading2>
                <p className="font-text">
                    نستخدم “الكوكيز” التي تحتوي على معلومات الملف الذي يمكننا من تحديد تفاصيل عنوان بروتكول الإنترنت، ونظام التشغيل الخاص بك (مثل مايكروسوفت ويندوز، ماك O / S، لينكس)، والمتصفح (مثل إنترنت إكسبلورر وسفاري، فايرفوكس، بالإضافة إلى نسخة من متصفح)، النطاق (سواء دخلت إلى الموقع من داخل المملكة أو أي مكان آخر) وغيرها من معلومات المستخدم (مثل اسم المستخدم الخاص بك
                </p>
                <ul>
                    <li>يجوز لنا استخدام المعلومات الناتجة عن الكوكيز للأغراض التالية:</li>
                    <li>أنماط حركة المرور من وإلى الموقع.</li>
                    <li>ضمان إظهار أي إعلان إلى الشخص الأنسب.</li>
                    <li>تمكينك من دخول الموقع واستخدام خدمات معينة وزيارة الأقسام التي يسمح بدخولها للأعضاء المسجلين فقط.</li>
                </ul>
                <p className="font-text">
                    يمكنك اختيار رفض ملفات “الكوكيز” عبر إغلاقها في المتصفح الخاص بك و / أو حذفها من القرص الصلب الخاص بك. أنت لا تحتاج إلى أن يكون “الكوكيز” فعالاً حتى تتمكن من استخدام الموقع، ولكن سوف تحتاج لهما عند تسجيل دخولك إلى الموقع والوصول إلى محتوى مخصص أو آمن،
                </p>

                <p className="font-text">
                    بعض صفحات الويب قد لا تعمل بشكل صحيح إذا تم إغلاق ملفات “الكوكيز”.
                    صور تنسيق الملف الشخصي (تعرف أيضاً بمنارات الويب)

                </p>

                <p className="font-text">
                    نوفر صور تنسيق الملف الشخصي لقياس سلوك المستخدم، لمساعدتنا في تحسين تجربة المستخدم، وإدارة محتوى الموقع. وقد نستخدم هذه الصور على هذا الموقع، وفي رسائل البريد الإلكتروني لدينا، وفي إعلاناتنا على مواقع أخرى، أو في إعلاناتنا على رسائل البريد الإلكتروني الأخرى
                </p>
                <Heading2 className=" mb-5 ">
                    موفرو المحتوى والمعلنون والشركاء
                </Heading2>
                <p className="font-text">
                    نحن لسنا مسؤولين عن ممارسات جمع البيانات، وسياسات الخصوصية أو محتوى المواقع الأخرى بخلاف ما لدينا على موقعنا، بما في ذلك أي موقع يمكن الوصول إليه عن طريق رابط موجود في أحد مواقعنا. يجب عليك الاتصال مع مشغلي تلك المواقع مباشرة إذا كنت ترغب في الاستفسار عن سياسات وممارسات الخصوصية الخاصة بها قبل تقديم معلوماتك الشخصية لهم. ومن مسؤوليتكم الحافظ على هذه المعلومات بخصوصية وسرية.
                </p>
                <Heading2 className=" mb-5 ">
                    الاختيار والرفض
                </Heading2>
                <p className="font-text">
                    في حال استخدمنا أو أفصحنا عن المعلومات المجمعة حول بياناتك الشخصية خارج نطاق الجمع، فإن استخدام أو الإفصاح عن معايير سياسة الخصوصية هذه، سنتركه خياراً لكم من خلال:
                </p>
                <ul>
                    <li>o	الرفض وعدم الحصول على خدمات معينة أو المشاركة في بعض المناطق تفاعلية</li>
                    <li>o	الاختيار على الموافقة على الاتصال من قبلنا فيما يتعلق بمسائل معينة مثل إخطار بالميزات الجديد في الموقع، اختبار بيتا أو الأنشطة الترويجية.</li>
                    <li>o	امتلاك، تصحيح وتحديث المعلومات</li>
                    <li>o	نتيح لك تصحيح أو تغيير المعلومات التي تم جمعها في أي وقت، وكلما اقتضت الحاجة إلى ذلك. إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه، يرجى الاتصال بنا عن طريق إرسال بريد إلكتروني إلى info@ko-design.ae.</li>
                </ul>

                <Heading2 className=" mb-5 ">
                    التعديلات
                </Heading2>

                <p className="font-text">
                    يجوز لنا تغيير سياسة الخصوصية هذه في أي وقت دون إشعار مسبق. أنت توافق على أن النسخة الحالية من سياسة الخصوصية تسري على استخدامك للموقع.
                </p>
                <Heading2 className=" mb-5 ">
                    التواصل
                </Heading2>
                <p className="font-text">
                    أي استفسارات أو تعليقات حول مواقع أو سياسة الخصوصية ينبغي أن توجه عبر البريد الإلكتروني باستخدام النموذج الموجود في صفحة “تواصل معنا” على الموقع.
                </p>

                <p className="font-text">
                </p>



            </div>

        </div>
    );
};
export default PrivacySection1;

